module.exports = __webpack_public_path__ + "static/media/button_edit.e3e59851.svg";